import { Alert, Box, Paper, Typography } from "@mui/material"
import { Bar, BarChart, CartesianGrid, Cell, LabelList, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts"

export const CORES = { ativo: "#16a34a", manutencao: "#dc2626", standBy: "#d97706" }
function Quadro({ titulo, vazio, children }) {
  return <Paper sx={{ p: 2, minWidth: 0 }}>
    <Typography component="h3" variant="subtitle1" fontWeight={600} sx={{ mb: 2 }}>{titulo}</Typography>
    {vazio ? <Alert severity="info">Sem dados disponíveis para esta análise.</Alert> : <Box sx={{ width: "100%", height: 330, minWidth: 0 }}>{children}</Box>}
  </Paper>
}
export function GraficoDias({ totais, titulo = "Dias registrados do equipamento" }) {
  const dias = [
    { nome: "Ativo registrado", dias: totais.diasAtivo, cor: CORES.ativo },
    { nome: "Manutenção", dias: totais.diasManutencao, cor: CORES.manutencao },
    { nome: "Stand-by", dias: totais.diasStandBy, cor: CORES.standBy }
  ]
  return <Box><Quadro titulo={titulo} vazio={!totais.diasRegistrados}>
    <ResponsiveContainer width="100%" height="100%"><BarChart data={dias} margin={{ top: 20, right: 15, bottom: 20, left: 0 }}>
      <CartesianGrid strokeDasharray="3 3" /><XAxis dataKey="nome" tick={{ fontSize: 10 }} interval={0} /><YAxis allowDecimals={false} />
      <Tooltip formatter={v => [v, "Dias corridos registrados"]} /><Bar dataKey="dias" name="Dias corridos registrados">{dias.map(d => <Cell key={d.nome} fill={d.cor} />)}<LabelList dataKey="dias" position="top" /></Bar>
    </BarChart></ResponsiveContainer>
  </Quadro></Box>
}
export default function GraficosAnalise({ dados }) {
  const oficinas = dados.ranking.map(r => ({ ...r, rotulo: `#${r.id_fornecedor} ${r.oficina}` }))
  return <Box sx={{ display: "grid", gridTemplateColumns: { xs: "minmax(0, 1fr)", lg: "repeat(2, minmax(0, 1fr))" }, gap: 2 }}>
    <Quadro titulo="Histórico por período — evolução mensal" vazio={!dados.evolucao.length}>
      <ResponsiveContainer width="100%" height="100%"><LineChart data={dados.evolucao} margin={{ top: 15, right: 20, bottom: 10 }}>
        <CartesianGrid strokeDasharray="3 3" /><XAxis dataKey="periodo" /><YAxis allowDecimals={false} /><Tooltip /><Legend wrapperStyle={{ fontSize: 11 }} />
        <Line type="linear" dataKey="diasAtivo" name="Ativo registrado" stroke={CORES.ativo} />
        <Line type="linear" dataKey="diasManutencao" name="Manutenção" stroke={CORES.manutencao} />
        <Line type="linear" dataKey="diasStandBy" name="Stand-by" stroke={CORES.standBy} />
      </LineChart></ResponsiveContainer>
    </Quadro>
    <Quadro titulo="10 oficinas mais utilizadas — visitas observadas" vazio={!oficinas.length}>
      <ResponsiveContainer width="100%" height="100%"><BarChart data={oficinas} layout="vertical" margin={{ top: 5, right: 35, bottom: 5, left: 5 }}>
        <CartesianGrid strokeDasharray="3 3" /><XAxis type="number" allowDecimals={false} /><YAxis type="category" dataKey="rotulo" width={130} tick={{ fontSize: 10 }} tickFormatter={s => s.length > 22 ? `${s.slice(0, 22)}…` : s} />
        <Tooltip /><Bar dataKey="visitas" name="Visitas observadas" fill="#3b82f6"><LabelList dataKey="visitas" position="right" /></Bar>
      </BarChart></ResponsiveContainer>
    </Quadro>
  </Box>
}
